export enum BankNestLevel {
	First = "first",
	Last = "last",
	Both = ""
}
